import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-link-cell-renderer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './link-cell-renderer.component.html',
  styleUrl: './link-cell-renderer.component.scss',
})
export class LinkCellRendererComponent<
  TValue,
  TData extends { id: string | number | null }
> implements ICellRendererAngularComp
{
  @Input() value: TValue | null | undefined = undefined;
  @Input() id: string | number | null | undefined = undefined;
  @Input() baseRoute: string | null | undefined = undefined;

  agInit(
    params: ICellRendererParams<
      TData,
      TValue,
      { baseRoute: string | null | undefined }
    >
  ): void {
    this.value = params.value;
    this.id = params.data?.id;
    this.baseRoute = params.context.baseRoute ?? null;
  }

  refresh(): boolean {
    return false;
  }
}
